import React from 'react';
import './index.css';
import clsx from 'classnames';
import { Position } from 'components';
import Compare from './components/Compare';
import System from './components/System';
import Demand from './components/Demand';
import DataDisplay from './components/DataDisplay';
import Highlight from './components/Highlight';
import { usePageTitle } from '../../hooks';

const Intelligence = () => {
  // 设置页面标题
  usePageTitle('数智化实验室');

  return (
    <div
      className={clsx('intelligence-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部Banner */}
      <div className={clsx('intelligence-top-img')}>
        <div className={clsx('intelligence-top-img-content')}>
          <div className={clsx('intelligence-top-img-content-title')}>
            数智<span>实验室管理系统</span>
          </div>
          <div className={clsx('intelligence-top-img-content-desc')}>
            Digital Intelligence Laboratory Management System
          </div>
        </div>
      </div>
      {/* 当前位置 */}
      <Position list={['首页', '数智化实验室']} />
      {/* 实验室比对 */}
      <Compare />
      {/* 系统功能 */}
      <System />
      {/* 数智化满足用户需求 */}
      <Demand />
      {/* 多元化数据管理 */}
      <DataDisplay />
      {/* 系统亮点 */}
      <Highlight />
    </div>
  );
};

export default Intelligence;
